
import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function TransactionIcon(props){
    return(
        <Svg width={props.size || 29}  height={props.size || 28} viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <Path d="M14.0872 4.86621L14.0872 23.1331C14.0872 23.8673 13.4843 24.2678 13.0879 23.797L4.71727 18.0285C4.2807 17.5099 5.93229 15.5 6.50127 15.5L10.3885 18.0285L10.3885 4.86621C10.3885 4.38832 10.6611 4.00092 10.9974 4.00092L13.4784 4.00092C13.8146 4.00092 14.0872 4.38832 14.0872 4.86621Z" fill={props?.color1 || "#667085"}/>
        <Path d="M15.6445 23.1338L15.6445 4.86694C15.6445 4.13272 16.2474 3.73216 16.6438 4.20302L25.0145 9.97148C25.451 10.4901 23.7995 12.5 23.2305 12.5L19.3432 9.97148L19.3432 23.1338C19.3432 23.6117 19.0706 23.9991 18.7344 23.9991L16.2534 23.9991C15.9171 23.9991 15.6445 23.6117 15.6445 23.1338Z" fill={props?.color2 || "#E4E7EC"}/>
        </Svg>
    )
}

export default TransactionIcon;